import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import User from "@/models/lms/User";
import Module from "@/models/lms/Module";
import Lesson from "@/models/lms/Lesson";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";

export default class LessonNote extends GenexLMSModel {
    static entity = 'lessonNotes'

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            user: this.belongsTo(User, 'user_id'),
            course_id: this.attr(null),
            module_id: this.attr(null),
            module: this.belongsTo(Module, 'module_id'),
            lesson: this.belongsTo(Lesson, 'lesson_id'),
            lesson_id: this.attr(null),
            content: this.attr(null),
            section: this.attr(null)
        }
    }

    /**
     * Returns all notes
     * @function
     * @param {Object} pagination
     * @param {number} pagination.page - Which page to retrieve
     * @param {number} pagination.limit - How many entities to retrieve
     * @param {?Object} [query={}] - Query terms for the request
     * @param {?number} [query.course_id] -
     * @param {?number} [query.lesson_id] -
     * @param {?number} [query.module_id] -
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchAll({page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/userlessonnotes`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        page: page, limit: limit, with: relationships
                    }, ...(query !== {} ? query : {}),
                },
                dataTransformer: ({data: {data}}) => {
                    return data.map(note => {

                        if (relationships.includes('user')) {
                            if (Object.prototype.hasOwnProperty.call(note, 'user')) {
                                Object.assign(note.attributes.user, note.attributes.user.attributes)
                            }
                        }
                        if (relationships.includes('module')) {
                            if (Object.prototype.hasOwnProperty.call(note, 'module')) {
                                Object.assign(note.attributes.module, note.attributes.module.attributes)
                            }
                        }
                        if (relationships.includes('lesson')) {
                            if (Object.prototype.hasOwnProperty.call(note, 'lesson')) {
                                Object.assign(note.attributes.lesson, note.attributes.lesson.attributes)
                            }
                        }

                        return {...note, ...note.attributes}
                    })
                },
            }
        )
    }

    /**
     * Returns a specific note
     * @function
     * @param {number} note_id - The note id
     * @param {Array.<string>} [relationships=[]] - Relationships to bring along
     * @returns {Promise<Response>}
     */

    static FetchById(note_id, relationships = [],) {
        return this.api().get(`/userlessonnotes/${note_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        with: relationships
                    },
                },
                dataTransformer: ({data: {data}}) => {

                    if (relationships.includes('user')) {
                        Object.assign(data.attributes.user, data.attributes.user.attributes)
                    }
                    return {...data, ...data.attributes}
                },
            }
        )
    }

    /**
     * Store a new lessonNote
     * @function
     * @param {Object} lessonNote - The note object
     * @returns {Promise<Response>} - The newly created note
     */

    static Store(lessonNote) {
        return this.api().post(`/userlessonnotes`, lessonNote, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            dataTransformer: ({data: {data}}) => {
                return {...data, ...data.attributes}
            },
        })
    }

    /**
     * Update a lessonNote
     * @function
     * @param {Object} lessonNote - The note object
     * @returns {Promise<Response>} - The newly created user
     */

    static Update(lessonNote) {
        return this.api().put(`/userlessonnotes/${lessonNote.id}`, lessonNote, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                dataTransformer: ({data: {data}}) => {
                    return {...data, ...data.attributes}
                },
            }
        )
    }

    /**
     * Delete a note
     * @function
     * @param {number} note_id - The id of the lessonNote
     * @returns {Promise<Response>}
     */

    static Delete(note_id) {
        return this.api().delete(`/userlessonnotes/${note_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                delete: note_id

            }
        )
    }
}
